// 商品ページの数量欄（#quantity_item）に「？」のヘルプ（数量の注意画像をポップアップで開く）を足す。fukuro.in だけ（Issue #78）。
// wuSiteResource2 の FukuroIn/ProductDetails.ts の showFancyBox() の引き取り先。
//
// 旧実装:
//   jQuery('#quantity_item').append('<a href="//www.fukuro.in/data/opp-fukuro/image/suryo_attention.jpg" class="quantity-help-popup" title="help">
//                                     <img src="//www.fukuro.in/data/opp-fukuro/image/hatena.png" alt="help" style="vertical-align: bottom"/></a>');
//   jQuery('.quantity-help-popup').fancybox({ autoScale:false, padding:'10', transitionIn:'fade', transitionOut:'fade',
//     onStart: undisplayFlash, onClosed: displayFlash, titlePosition:'inside', titleFormat: () => '<a … onclick="jQuery.fancybox.close();">' + close + '</a>' })
//
// 旧との差（Issue #78 の指示）:
//   - titleFormat の close は旧ではグローバルの close（おちゃのこ側で var close = "閉じる" が無ければ window.close 関数が文字列化されていた）。
//     ここでは「閉じる」の固定文字列
//   - undisplayFlash / displayFlash は無いページもあるので、関数のときだけ呼ぶ
//   - fancybox（jQuery.fn.fancybox）が無ければリンクだけ足して終わり（押すと画像そのものが開く）
// ★ 旧の読み込みは 2026-09-23 に既に外れている（そのせいで止まっていた）ので過渡期の二重動作は無いが、
//   念のため .quantity-help-popup が既にあれば足さない。

import { afterOldScripts } from '../shared/after-old-scripts'

export const QUANTITY_HELP_IMAGE = '//www.fukuro.in/data/opp-fukuro/image/suryo_attention.jpg'
export const QUANTITY_HELP_ICON = '//www.fukuro.in/data/opp-fukuro/image/hatena.png'
export const QUANTITY_HELP_CLASS = 'quantity-help-popup'
export const CLOSE_LABEL = '閉じる'

/** #quantity_item にヘルプリンクを足す。無い・既にあるなら false */
export function insertQuantityHelp(doc: Document): boolean {
  const box = doc.getElementById('quantity_item')
  if (!box || box.querySelector(`.${QUANTITY_HELP_CLASS}`)) return false
  const a = doc.createElement('a')
  a.href = QUANTITY_HELP_IMAGE
  a.className = QUANTITY_HELP_CLASS
  a.title = 'help'
  const img = doc.createElement('img')
  img.src = QUANTITY_HELP_ICON
  img.alt = 'help'
  img.style.verticalAlign = 'bottom'
  a.appendChild(img)
  box.appendChild(a)
  return true
}

type FlashFns = { undisplayFlash?: unknown; displayFlash?: unknown }

/** 旧実装と同じ fancybox のオプション。フラッシュの表示切替は関数があるときだけ */
export function fancyboxOptions(win: FlashFns): Record<string, unknown> {
  const call = (name: keyof FlashFns): void => {
    const fn = win[name]
    if (typeof fn === 'function') (fn as () => void)()
  }
  return {
    autoScale: false,
    padding: '10',
    transitionIn: 'fade',
    transitionOut: 'fade',
    onStart: () => call('undisplayFlash'),
    onClosed: () => call('displayFlash'),
    titlePosition: 'inside',
    titleFormat: () => `<a href="javascript:void(0);" onclick="jQuery.fancybox.close();">${CLOSE_LABEL}</a>`,
  }
}

type JQWithFancybox = ((sel: string) => { fancybox?: (opts: Record<string, unknown>) => unknown }) & {
  fn?: { fancybox?: unknown }
}

export default function quantityHelp(): void {
  // ★ fancybox（jQuery.fn.fancybox）はおちゃのこの ocnk-min.js が jQuery ready の中で用意するらしく、storefront.js（defer）の
  //   実行時点ではまだ無い（2026-09-23 に fukuro.in の複製で実測: ready 前に呼ぶとリンクだけ足されて click が束ねられない）。
  //   旧実装は jQuery ready の中で呼んでいたので間に合っていた。load + 1 マクロタスク後（shared/after-old-scripts.ts）に回す
  afterOldScripts(() => {
    if (!insertQuantityHelp(document)) return
    const jq = (window as unknown as { jQuery?: JQWithFancybox }).jQuery
    if (typeof jq !== 'function' || typeof jq.fn?.fancybox !== 'function') return
    try {
      jq(`.${QUANTITY_HELP_CLASS}`).fancybox?.(fancyboxOptions(window as unknown as FlashFns))
    } catch (e) {
      // 旧実装も try/catch で握り潰していた。リンクは残るので画像は開ける
      console.warn('[wu] quantity-help: fancybox の初期化に失敗しました', e)
    }
  })
}
